<template>
    <div class="intro">
<!--        弹窗-->
        <el-dialog title="活动介绍" :visible.sync="visible" width="440px" :before-close="handleClose" :append-to-body="true">
            <el-form ref="form" size="small" :model="form" label-position="top" v-loading="loading">
                <el-form-item label="视频：">
                    <div class="draggable-list">
                        <div v-if="form.video_id == 0" class="item img-select" @click="openGoodsUpload('video', 'video')"><i class="el-icon-plus"></i></div>
                        <div v-if="form.video_id != 0">
                            <video width="400" height="150" :src="form.video.file_path" :autoplay="false" controls>
                                您的浏览器不支持 video 标签
                            </video>
                            <el-button type="danger" icon="el-icon-close" @click="delVideo">删除视频</el-button>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="视频封面：">
                    <div class="draggable-list">
                        <div v-if="form.poster_id == 0" class="item img-select" @click="openGoodsUpload('image', 'poster')"><i class="el-icon-plus"></i></div>
                        <div v-if="form.poster_id != 0" class="item">
                            <el-image :src="form.poster.file_path" :preview-src-list="[form.poster.file_path]" style="width: 110px; height: 110px;"></el-image>
                            <a href="javascript:void(0);" class="delete-btn" @click.stop="delVideoImg()"><i class="el-icon-close"></i></a>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="介绍：">
                    <Uediter ref="ue" editor_id="introEditer" :text="form.content" :config="ueditor.config" @contentChange="contentChangeFunc"></Uediter>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="visible = false">取消</el-button>
                <el-button size="small" type="primary"  @click="onSubmit">{{ loading ? "提交中..." : "确 定" }}</el-button>
            </div>
        </el-dialog>
        <!--商品图片组件-->
        <Upload v-if="isUpload" :config="config" :isupload="isUpload" @returnImgs="returnGoodsImgsFunc">上传图片</Upload>
    </div>
</template>

<script>
    import Uediter from "@/components/UE.vue";
    import Upload from "@/components/file/Upload";
    import PlatformActivityApi from "@/api/platformactivity.js";
    export default {
        components: {
            Upload,
            Uediter
        },
        props: {
        },
        data() {
            return {
                isUpload: false,
                /*富文本框配置*/
                ueditor: {
                    text: "",
                    config: {
                        initialFrameWidth: 400,
                        initialFrameHeight: 500
                    }
                },
                visible: false,
                loading: false,
                form: {
                    content: "",
                    video_id: 0,
                    poster_id: 0,
                },
                activity_id: 0
            };
        },
        created() {},
        methods: {
            /*获取富文本内容*/
            contentChangeFunc(e) {
                this.form.content = e;
            },
            getData () {
                this.loading = true
                PlatformActivityApi.activity.intro({
                    activity_id: this.activity_id
                }).then((res) => {
                    this.loading = false
                    if(res.code === 1) {
                        this.form = res.data.detail;
                        this.$refs.ue.setUEContent(this.form.content);
                    }
                }).catch((error) => {
                    this.loading = false
                })
            },
            showDialog(activity_id){
                this.activity_id = activity_id
                this.visible = true
                this.getData();
            },
            handleClose(done) {
                this.visible = false
                this.form = {
                    content  : '',
                    video_id : 0,
                    poster_id: 0,
                }
            },
            onSubmit() {
                if(this.loading){
                    return;
                }
                this.loading = true;
                PlatformActivityApi.activity.editIntro({
                    activity_id: this.activity_id,
                    content: this.form.content,
                    poster_id: this.form.poster_id,
                    video_id: this.form.video_id
                }).then((data) => {
                    this.loading = false;
                    this.$message({
                        message: data.msg,
                        type: "success"
                    });
                    this.visible = false
                }).catch((error) => {})
            },
            /*打开上传图片*/
            openGoodsUpload: function(file_type, file_name) {
                this.file_name = file_name;
                if (file_type == "image") {
                    this.config = {
                        total: 9,
                        file_type: "image"
                    };
                } else {
                    this.config = {
                        total: 1,
                        file_type: "video"
                    };
                }
                this.isUpload = true;
            },

            /*上传商品图片*/
            returnGoodsImgsFunc(e) {
                if (e != null) {
                    if (this.file_name == "video") {
                        this.form.video_id = e[0].file_id;
                        this.form.video = e[0];
                    } else if (this.file_name == "image") {
                        let imgs = this.form.image.concat(e);
                        this.$set(this.form, "image", imgs);
                    } else if (this.file_name == "poster") {
                        this.form.poster_id = e[0].file_id;
                        this.form.poster = e[0];
                    }
                }
                this.isUpload = false;
            },

            delVideo() {
                this.form.video_id = 0;
                this.form.video = {};
            },
            delVideoImg() {
                this.form.model.poster_id = 0;
            },
        }
    };
</script>

<style>
#edui_fixedlayer {
    z-index: 9999 !important;
}
.draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
}

.draggable-list .item:hover .delete-btn {
    display: block;
}

.draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
}

.draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
}

.draggable-list .img-select i {
    color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/platformactivity/part/Intro.vue